if (!customElements.get('prinzap-options')) customElements.define('prinzap-options', class extends HTMLElement {
 connectedCallback() {
  this.form=document.getElementById(this.dataset.formId);
  this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);
  this.options=JSON.parse(this.querySelector('[data-options]').textContent);
  this.update=()=>{
   const variant=this.variants.find(v=>String(v.id)===this.form?.querySelector('[name="id"]')?.value);
   for(const kind of ['text','color']) {
    const index=this.options.findIndex(label=>kind==='text'?/personalis|beschrift/i.test(label):/farbkombination/i.test(label));
    const active=index>=0&&/^(ja|custom)$/i.test(variant?.options[index]||'');
    const field=this.querySelector('[data-kind="'+kind+'"]');field.hidden=!active;
    const input=field.querySelector('input');input.disabled=!active;input.required=active;
   }
  };
  this.form?.addEventListener('change',this.update);this.update();
 }
 disconnectedCallback(){this.form?.removeEventListener('change',this.update);}
});
